import {defineStore, storeToRefs} from 'pinia'
import {config} from "@/core/config";
import {useGetTheLookStore} from "@/store/getTheLookStore";


interface StylisationProduct {
  [key: string]: string | number | Array<string> | boolean;
}

export const useStylisationStore = defineStore('stylisationStore', {
  state: () => {
    return {
      stylisationLoading: true,
      stylisationId: null as string | null,
      stylisationProduct: {} as StylisationProduct
    }
  },
  getters: {
    getStylisationLoading(state) {
      return state.stylisationLoading
    },
    getStylisationId(state) {
      return state.stylisationId
    },
    getStylisationProduct(state) {
      return state.stylisationProduct
    },
    hasStylisation(state) {
      return !(Object.keys(state.stylisationProduct).length === 0 && state.stylisationProduct.constructor === Object)
    }
  },
  actions: {
    setStylisationLoading(value: boolean) {
      this.stylisationLoading = value
    },
    setStylisationProduct(product: StylisationProduct) {
      this.stylisationProduct = product
    },
    setStylisationId(stylisationId: string | null) {
      this.stylisationId = stylisationId
    },
    async fetchStylisation() {
      this.getStylisationIdFromHash()
      if (!this.getStylisationId) {
        return
      }
      const {customerSymbol, catalogId, apiKey, apiHost} = config
      try {
        const response = await fetch(
          `https://${apiHost}/restapi/${customerSymbol}/catalog/${catalogId}/product/${this.getStylisationId}`,
          {
            method: 'GET',
            headers: {
              'Api-key': apiKey,
            },
            credentials: 'include',
          }
        )
        
        if (response.ok) {
          const {product} = await response.json()
          const stylisation = product || {}
          this.setStylisationProduct(stylisation)
          setTimeout(() => {
            this.setStylisationLoading(false)
          }, 300)
        }
      } catch (error) {
        this.setStylisationLoading(false)
      }
    },
    
    
    getStylisationIdFromHash() {
      let params = window.location.hash
      let queryParams = new URLSearchParams(params.slice(2))
      if (!config.useHashBeforeParams) {
        params = window.location.search
        queryParams = new URLSearchParams(params.slice(1))
      }
      const stylisationId = queryParams.get('stylisation')
      if (!stylisationId) {
        this.setStylisationLoading(false)
      }
      this.setStylisationId(stylisationId)
    },
    
    
    async updateHash() {
      this.getStylisationIdFromHash()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!this.getStylisationId) {
        return
      }
      await this.fetchStylisation()
      const getTheLookStore = useGetTheLookStore()
      await getTheLookStore.fetchGetTheLooksCategorized()
      
      if (!this.stylisationLoading && this?.stylisationProduct) {
        document.title = this?.stylisationProduct?.title as string
      }
    }
  }
})